document.addEventListener('DOMContentLoaded',()=>{
  const nodes=document.querySelectorAll('[data-countdown]');
  nodes.forEach(el=>{
    const key='sp00kyFlashEnd';
    let end=localStorage.getItem(key);
    if(!end || Number(end)<Date.now()){ end=Date.now()+1000*60*60*7+1000*60*43; localStorage.setItem(key,end); }
    const tick=()=>{let s=Math.max(0,Math.floor((Number(end)-Date.now())/1000));let h=Math.floor(s/3600),m=Math.floor((s%3600)/60),sec=s%60;el.textContent=[h,m,sec].map(x=>String(x).padStart(2,'0')).join(':')};tick();setInterval(tick,1000);
  });
  const mobile=document.querySelector('[data-menu]');
  const nav=document.querySelector('[data-nav]');
  if(mobile&&nav) mobile.addEventListener('click',()=>nav.classList.toggle('open'));
  const live=document.querySelector('[data-live]');
  if(live){let n=23;setInterval(()=>{n=Math.max(12,Math.min(39,n+(Math.random()>.55?1:-1)));live.textContent='🛒 '+n+' personas están viendo esto ahora mismo';},4200)}
});
